/* ============================================================
   BYG BEREICH-FILTER (Manuel, 05.10.2026: "viel zu detailliert zum
   Filtern ... einfach nach den Kacheln").

   Ein zusaetzlicher Filter "Bereich" in der Filterleiste der
   Kollektion. Er kennt die zwoelf Kacheln aus assets/byg-kacheln.json
   und setzt beim Klick filter.p.product_type fuer jeden Typ der Kachel
   (Shopify verknuepft mehrere Werte mit ODER) plus bereich=<slug>.
   Alle anderen Filter — vor allem das Bike — bleiben stehen.

   WELCHER BEREICH IST AKTIV?
     1. bereich=<slug> in der URL, wenn alle gewaehlten Typen dazu gehoeren
     2. sonst: die gewaehlten Typen sind genau die Typen einer Kachel
     3. sonst: alle gewaehlten Typen gehoeren zu einer Kachel (die erste)
   Faelle 1 und 3 decken "Bereich Motor, darin nur Kolben" ab. Honeys
   facets.js verliert bereich= beim AJAX-Neuladen; dann greift 3.

   PRODUKTTYP IM BEREICH (Manuel, 05.10.2026: "nur die moeglichen
   Filtermoeglichkeiten, die unter Motor fallen"): Ist ein Bereich aktiv,
   zeigt das Dropdown "Produkttyp" nur noch dessen Typen — und davon nur
   die mit Treffern (Zahl > 0, so wie Shopify sie fuer die uebrigen Filter
   ausgibt). Erste Zeile "Alle Teile im Bereich", danach je Typ ein Link,
   der genau diesen einen Typ waehlt. Die vielen Einzel-Pillen werden
   ausgeblendet, solange der ganze Bereich gewaehlt ist.

   Desktop: Dropdown an erster Stelle. Mobil: wischbare Chip-Reihe.
   Ein MutationObserver setzt alles nach Honeys AJAX-Neuladen wieder ein.
   ============================================================ */
(function () {
  /* document.currentScript ist hier null (im Theme nachgemessen) —
     deshalb ueber das data-Attribut suchen. */
  var skript = document.currentScript || document.querySelector('script[data-kacheln]');
  var pfad = skript && skript.getAttribute('data-kacheln');
  if (!pfad || !window.fetch) return;
  var KACHELN = null;
  var ANZEIGE = {};

  function params() { return new URLSearchParams(window.location.search); }
  function aktuelleTypen() { return params().getAll('filter.p.product_type'); }
  function gleich(a, b) { return a.slice().sort().join('|') === b.slice().sort().join('|'); }
  function alleIn(t, k) { for (var i = 0; i < t.length; i++) if (k.typen.indexOf(t[i]) < 0) return false; return true; }

  /* { k: Kachel, ganz: true wenn alle Typen der Kachel gewaehlt sind } */
  function zustand() {
    var t = aktuelleTypen();
    if (!t.length) return null;
    var slug = params().get('bereich'), i;
    if (slug) for (i = 0; i < KACHELN.length; i++) if (KACHELN[i].slug === slug && alleIn(t, KACHELN[i])) return { k: KACHELN[i], ganz: gleich(t, KACHELN[i].typen) };
    for (i = 0; i < KACHELN.length; i++) if (gleich(t, KACHELN[i].typen)) return { k: KACHELN[i], ganz: true };
    for (i = 0; i < KACHELN.length; i++) if (alleIn(t, KACHELN[i])) return { k: KACHELN[i], ganz: false };
    return null;
  }

  function link(k, typen) {
    var u = new URL(window.location.href);
    u.searchParams.delete('filter.p.product_type');
    u.searchParams.delete('bereich');
    u.searchParams.delete('page');
    if (k) {
      (typen || k.typen).forEach(function (t) { u.searchParams.append('filter.p.product_type', t); });
      u.searchParams.set('bereich', k.slug);
    }
    if (!u.searchParams.has('sort_by')) u.searchParams.set('sort_by', 'manual');
    return u.pathname + u.search;
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function schliessbar(col) {
    var det = col.querySelector('details');
    document.addEventListener('click', function (e) { if (det.open && !col.contains(e.target)) det.open = false; });
    det.addEventListener('keydown', function (e) { if (e.key === 'Escape') { det.open = false; det.querySelector('summary').focus(); } });
  }

  /* NUR BEREICHE MIT TREFFERN (15.10.2026): Vorher standen immer alle
     zwoelf Kacheln da — auf /collections/motor-tuning zehn davon ohne ein
     einziges Teil, der Klick fuehrte ins Leere. Die Summe je Kachel kommt
     aus Honeys Produkttyp-Zaehlern ("Kolben (3)"); Shopify rechnet sie
     mit allen uebrigen Filtern (auch dem Bike) und OHNE den Typ-Filter
     selbst — ein Wechsel zwischen Bereichen bleibt also moeglich. Der
     aktive Bereich bleibt immer stehen. Gibt es auf der Seite keinen
     Produkttyp-Filter, ist nichts bekannt: dann bleiben alle stehen. */
  function summen(wurzel) {
    if (!wurzel || !wurzel.querySelector('input[name="filter.p.product_type"]')) return null;
    var zahl = zahlen(wurzel), s = {};
    KACHELN.forEach(function (k) {
      var gesehen = {}, n = 0;
      k.typen.forEach(function (t) { if (!gesehen[t]) { gesehen[t] = 1; n += zahl[t] || 0; } });
      s[k.slug] = n;
    });
    return s;
  }
  function sichtbar(k, s, aktiv) { return aktiv === k || !s || s[k.slug] > 0; }

  /* PFEIL (15.10.2026): Font Awesome tauscht die <i>-Pfeile der anderen
     Filter erst NACH dem Einfuegen gegen ein svg — der einmalige Klon beim
     Bauen griff deshalb oft ins Leere und "Bereich" stand ohne Pfeil da.
     setzen() laeuft nach jeder Aenderung im Filterbereich (Observer) und
     holt den Pfeil hier nach, sobald einer da ist. Ersatz: ein schlichter
     Pfeil in derselben Groesse. */
  function pfeil(col) {
    var text = col && col.querySelector('.facets__summary__text');
    if (!text) return;
    var alt = text.querySelector('[data-byg-pfeil]');
    if (text.querySelector('svg:not([data-byg-pfeil])')) return;
    var vorlage = document.querySelector('#FacetFiltersForm .facets__filters__column:not([data-byg-bereich]) .facets__summary__text > svg');
    if (vorlage) {
      if (alt) alt.remove();
      text.appendChild(vorlage.cloneNode(true));
    } else if (!alt) {
      text.insertAdjacentHTML('beforeend', '<svg data-byg-pfeil class="icon icon-chevron-down svg-inline--fa fa-chevron-down" aria-hidden="true" focusable="false" viewBox="0 0 512 512" width="12" height="12"><path fill="currentColor" d="M256 390.6 39.4 174 73.4 140l182.6 182.6L438.6 140l34 34z"/></svg>');
    }
  }

  function desktop(z) {
    var wrap = document.querySelector('#FacetFiltersForm .facets__filters-wrap');
    if (!wrap) return;
    var da = wrap.querySelector('[data-byg-bereich]');
    if (da) { pfeil(da); return; }
    var aktiv = z && z.k;
    var s = summen(document.querySelector('#FacetFiltersForm'));
    var col = document.createElement('div');
    col.className = 'facets__filters__column byg-bereich';
    col.setAttribute('data-byg-bereich', '');
    col.innerHTML =
      '<details class="facets__filters__details facets__disclosure byg-bereich__details">' +
        '<summary class="facets__summary" role="button"><div class="facets__summary__text"><span>Bereich</span></div></summary>' +
        '<div class="facets__display byg-bereich__display"><ul class="byg-bereich__liste" role="list">' +
          KACHELN.filter(function (k) { return sichtbar(k, s, aktiv); }).map(function (k) {
            return '<li><a class="byg-bereich__opt' + (aktiv === k ? ' is-aktiv' : '') + '" href="' + esc(link(k)) + '"' + (aktiv === k ? ' aria-current="true"' : '') + '>' +
              '<span>' + esc(k.name) + '</span>' + (s ? '<span class="byg-typ__n">' + s[k.slug] + '</span>' : '') + '</a></li>';
          }).join('') +
        '</ul></div>' +
      '</details>';
    wrap.insertBefore(col, wrap.firstChild);
    pfeil(col);
    schliessbar(col);
  }

  /* Produkttyp auf den Bereich eingrenzen. Die Zahlen kommen aus Honeys
     eigener Liste ("Kolben (3)") — Shopify rechnet sie mit allen
     uebrigen Filtern, also auch mit dem Bike. Dieselbe Liste dient dem
     Desktop-Dropdown und dem Handy-Menue "Filtern und sortieren". */
  function zahlen(wurzel) {
    var zahl = {};
    var inps = wurzel.querySelectorAll('input[name="filter.p.product_type"]');
    for (var i = 0; i < inps.length; i++) {
      var lab = inps[i].closest('label') || inps[i].parentNode;
      var txt = lab && (lab.querySelector('.facet-checkbox__text') || lab.querySelector('.mobile-facets__label-text'));
      var m = txt ? txt.textContent.match(/\((\d+)\)\s*$/) : null;
      zahl[inps[i].value] = m ? parseInt(m[1], 10) : 0;
    }
    return zahl;
  }
  function typListe(z, zahl) {
    var jetzt = aktuelleTypen();
    var gesehen = {};
    var zeilen = z.k.typen.filter(function (t) {
      if (gesehen[t]) return false; gesehen[t] = 1;
      return zahl[t] > 0;
    }).map(function (t) {
      var an = !z.ganz && jetzt.length === 1 && jetzt[0] === t;
      return '<li><a class="byg-typ__opt' + (an ? ' is-aktiv' : '') + '" href="' + esc(link(z.k, [t])) + '">' +
        '<span>' + esc(ANZEIGE[t] || t) + '</span><span class="byg-typ__n">' + zahl[t] + '</span></a></li>';
    });
    var ul = document.createElement('ul');
    ul.className = 'byg-typ__liste';
    ul.setAttribute('data-byg-typliste', '');
    ul.setAttribute('role', 'list');
    ul.innerHTML =
      '<li><a class="byg-typ__opt byg-typ__opt--alle' + (z.ganz ? ' is-aktiv' : '') + '" href="' + esc(link(z.k)) + '"><span>Alle Teile: ' + esc(z.k.name) + '</span></a></li>' +
      (zeilen.length ? zeilen.join('') : '<li class="byg-typ__leer">Keine Treffer in diesem Bereich.</li>');
    return ul;
  }
  function typenImBereich(z) {
    var col = document.querySelector('#FacetFiltersForm [id^="Wrap-Filter-produkttyp"]');
    if (!col) return;
    var alt = col.querySelector('[data-byg-typliste]');
    if (!z) { col.classList.remove('byg-typ-bereich'); if (alt) alt.remove(); return; }
    if (alt) return;
    var fs = col.querySelector('.facets-wrap') || col.querySelector('.facets__display');
    if (!fs) return;
    fs.appendChild(typListe(z, zahlen(col)));
    col.classList.add('byg-typ-bereich');
  }
  function typenImBereichMobil(z) {
    var inp = document.querySelector('#FacetFiltersFormMobile input[name="filter.p.product_type"]');
    var menue = inp && inp.closest('.mobile-facets__submenu');
    if (!menue) return;
    var alt = menue.querySelector('[data-byg-typliste]');
    if (!z) { menue.classList.remove('byg-typ-bereich'); if (alt) alt.remove(); return; }
    if (alt) return;
    var ul = typListe(z, zahlen(menue));
    menue.insertBefore(ul, menue.firstChild);
    menue.classList.add('byg-typ-bereich');
    /* Ueberschrift: Honey zaehlt die gewaehlten Typen ("Produkttyp (28)").
       Ist der ganze Bereich gewaehlt, steht dort stattdessen der Bereich. */
    var det = menue.closest('details');
    var kopf = det && det.querySelector('summary span');
    if (kopf && z.ganz) kopf.textContent = 'Produkttyp: alle ' + z.k.name;
  }

  /* EINE ZEILE (Manuel, 05.10.2026): Filter mit gewaehltem Wert werden zu
     einem einzigen Knopf "Wert ▾ ×" zusammengezogen statt Dropdown plus
     Pille daneben. Der Pfeil oeffnet weiter das Dropdown, das x loescht.
     Bei mehreren Werten steht "Marke · 2" im Knopf; geloescht wird dann
     im Dropdown. Das Bike bleibt die Startnummerntafel — dort entfaellt
     stattdessen der Kasten "Passende Modelle" (Bike aendern: Leiste). */
  function chipText(a) {
    var c = a.cloneNode(true);
    var vh = c.querySelectorAll('.visually-hidden');
    for (var i = 0; i < vh.length; i++) vh[i].remove();
    return c.textContent.replace(/\s+/g, ' ').trim();
  }
  function knopf(col, text, xHref) {
    col.classList.add('byg-gewaehlt');
    var span = col.querySelector('.facets__summary__text > span');
    if (span) span.textContent = text;
    var alt = col.querySelector('.byg-x');
    if (alt) alt.remove();
    if (xHref) {
      var x = document.createElement('a');
      x.className = 'byg-x';
      x.href = xHref;
      x.setAttribute('aria-label', text + ' entfernen');
      x.innerHTML = '<span aria-hidden="true">&times;</span>';
      col.querySelector('details').insertAdjacentElement('afterend', x);
    }
  }
  function verdichten(z) {
    var cols = document.querySelectorAll('#FacetFiltersForm .facets__filters__column');
    for (var i = 0; i < cols.length; i++) {
      var col = cols[i];
      if (col.hasAttribute('data-byg-verdichtet')) continue;
      col.setAttribute('data-byg-verdichtet', '');
      if (col.hasAttribute('data-byg-bereich')) {
        if (z) knopf(col, z.k.name, link(null));
        continue;
      }
      var chips = col.querySelectorAll('.active-facets a[href]');
      if (!chips.length) continue;
      if (/^Wrap-Filter-(passende-modelle|modell)/.test(col.id)) { col.classList.add('byg-nur-tafel'); continue; }
      if (/^Wrap-Filter-produkttyp/.test(col.id) && z) {
        if (z.ganz) { col.classList.add('byg-typ-still'); continue; }
        var t = aktuelleTypen();
        knopf(col, t.length === 1 ? (ANZEIGE[t[0]] || t[0]) : 'Produkttyp · ' + t.length, link(z.k));
        continue;
      }
      var name = (col.querySelector('.facets__summary__text > span') || {}).textContent || '';
      knopf(col, chips.length === 1 ? chipText(chips[0]) : name.trim() + ' · ' + chips.length, chips.length === 1 ? chips[0].href : null);
    }
  }

  function mobil(z) {
    var dr = document.querySelector('.mobile-facets__wrapper');
    if (!dr || document.querySelector('[data-byg-bereich-mobil]')) return;
    var aktiv = z && z.k;
    var s = summen(document.querySelector('#FacetFiltersFormMobile') || document.querySelector('#FacetFiltersForm'));
    var reihe = document.createElement('nav');
    reihe.className = 'byg-bereich-mobil';
    reihe.setAttribute('data-byg-bereich-mobil', '');
    reihe.setAttribute('aria-label', 'Bereich');
    reihe.innerHTML = KACHELN.filter(function (k) { return sichtbar(k, s, aktiv); }).map(function (k) {
      var an = aktiv === k;
      return '<a class="byg-bereich-mobil__chip' + (an ? ' is-aktiv' : '') + '" href="' + esc(link(an ? null : k)) + '"' + (an ? ' aria-current="true"' : '') + '>' + esc(k.name) + '</a>';
    }).join('');
    dr.parentNode.insertBefore(reihe, dr);
    var a = reihe.querySelector('.is-aktiv');
    if (a) reihe.scrollLeft = a.offsetLeft - 16;
  }

  /* Die Einzel-Pillen der Produkttypen (mobil stehen sie ausserhalb der
     Filter-Spalten, CSS allein erreicht sie nicht): eine Pille, deren Link
     genau EINEN Produkttyp weniger hat als die Seite, ist eine Typ-Pille.
     Ist der GANZE Bereich gewaehlt, ersetzt dessen Pille sie alle. */
  function typPillen(z) {
    var jetzt = aktuelleTypen().length;
    var l = document.querySelectorAll('.facets-container facet-remove a[href]');
    for (var i = 0; i < l.length; i++) {
      var a = l[i];
      if (a.closest('[data-byg-bereich]')) continue;
      var n = new URL(a.href, window.location.origin).searchParams.getAll('filter.p.product_type').length;
      var typ = jetzt > 0 && n === jetzt - 1;
      var huelle = a.closest('facet-remove') || a;
      if (typ && z && z.ganz) huelle.setAttribute('data-byg-typpille', '');
      else huelle.removeAttribute('data-byg-typpille');
    }
  }

  function setzen() {
    if (!KACHELN) return;
    var z = zustand();
    document.body.classList.toggle('byg-bereich-aktiv', !!(z && z.ganz));
    desktop(z);
    typenImBereich(z);
    verdichten(z);
    mobil(z);
    typenImBereichMobil(z);
    typPillen(z);
    bikePille();
  }

  /* HANDY: die Pille des Bike-Filters ("KTM 150 SX x") steht doppelt —
     die schwarze Bike-Leiste darunter zeigt dasselbe (Manuel, 05.10.2026:
     "Pille auf dem Handy weglassen"). Markiert wird jede Pille, deren Link
     den Modellfilter entfernt; ausgeblendet wird per CSS nur unter 750px. */
  function bikePille() {
    var hat = params().has('filter.p.m.byg.modelle');
    /* Nur echte Filter-Pillen, nicht "Alle loeschen" (.active-facets__button-remove). */
    var l = document.querySelectorAll('.facets-container facet-remove a.active-facets__button[href]');
    for (var i = 0; i < l.length; i++) {
      var a = l[i];
      var huelle = a.closest('facet-remove') || a;
      var weg = hat && !new URL(a.href, window.location.origin).searchParams.has('filter.p.m.byg.modelle');
      if (weg) huelle.setAttribute('data-byg-bikepille', '');
      else huelle.removeAttribute('data-byg-bikepille');
    }
  }

  fetch(pfad, { credentials: 'same-origin' })
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function (j) {
      KACHELN = j.kacheln || [];
      ANZEIGE = j.anzeige || {};
      /* KURZE LINKS FUERS MENUE (05.10.2026): /collections/all?bereich=motor
         wird hier zum vollen Produkttyp-Filter der Kachel erweitert. So muss
         im Menue nicht eine 1,8 KB lange Adresse stehen, und neue Typen in
         byg-kacheln.json gelten sofort auch fuer die Menuepunkte. */
      var p0 = params(), s0 = p0.get('bereich');
      if (s0 && !p0.getAll('filter.p.product_type').length) {
        for (var i0 = 0; i0 < KACHELN.length; i0++) {
          if (KACHELN[i0].slug === s0) { window.location.replace(link(KACHELN[i0])); return; }
        }
      }
      setzen();
      var ziel = document.getElementById('main-collection-filters') || document.body;
      new MutationObserver(function () { setzen(); }).observe(ziel, { childList: true, subtree: true });
    })
    .catch(function () {});
})();
